export enum ResponseType {
  RECEIVED,
  ACCEPTED,
  REJECT,
  DONT_KNOW,
}

export namespace ResponseType {
  let elements = [
    ResponseType.RECEIVED,
    ResponseType.ACCEPTED,
    ResponseType.REJECT,
    ResponseType.DONT_KNOW,
  ];
  let alias = "com.bcdfx.api.event.LifeCycleEventResponse.ResponseType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
